import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoginNavbar } from '../../components/layout/Navbar';

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <>
      <LoginNavbar />
      <div className="about-container">
        <div className="about-back-button">
          <Link to="/login" className="back-button">
            {t('privacyPage.backToLogin')}
          </Link>
        </div>
        <div className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">{t('privacyPage.title')}</h1>
            <p className="privacy-policy-updated">{t('privacyPage.lastUpdated')}</p>
          </div>
        </div>

        <div className="about-content">

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section1Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section1Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section2Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section2Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section3Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section3Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section4Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section4Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section5Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section5Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section6Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section6Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('privacyPage.section7Title')}</h2>
              <p className="about-section-text">{t('privacyPage.section7Text')}</p>
            </div>
          </div>

        </div>
      </div>
      <Footer className="about-footer" />
    </>
  );
};

export default PrivacyPolicy;